import { FinancialTransaction } from '../types';

export const transactionData: FinancialTransaction[] = [
  {
    id: 1,
    date: "2025-03-01",
    type: "owner_draw",
    amount: 10000.00,
    description: "Monthly owner draw - Jordan Black",
    fromAccount: "Operating",
    recipient: "Jordan Black"
  },
  {
    id: 2,
    date: "2025-03-05",
    type: "loan_payback",
    amount: 5000.00,
    description: "SBA Loan Payment",
    fromAccount: "Operating",
    toAccount: "Loan Account"
  },
  {
    id: 3,
    date: "2025-03-10",
    type: "transfer",
    amount: 25000.00,
    description: "Transfer to tax reserve account",
    fromAccount: "Operating",
    toAccount: "Tax Reserve"
  },
  {
    id: 4,
    date: "2025-03-15",
    type: "owner_draw",
    amount: 5000.00,
    description: "Owner draw - Eric Black",
    fromAccount: "Operating",
    recipient: "Eric Black"
  },
  {
    id: 5,
    date: "2025-03-20",
    type: "loan_payback",
    amount: 3500.00,
    description: "Equipment loan payment",
    fromAccount: "Operating",
    toAccount: "Equipment Loan"
  },
  {
    id: 6,
    date: "2025-03-25",
    type: "transfer",
    amount: 15000.00,
    description: "Transfer to payroll account",
    fromAccount: "Operating",
    toAccount: "Payroll"
  },
  {
    id: 7,
    date: "2025-04-01",
    type: "owner_draw",
    amount: 10000.00,
    description: "Monthly owner draw - Jordan Black",
    fromAccount: "Operating",
    recipient: "Jordan Black"
  },
  {
    id: 8,
    date: "2025-04-05",
    type: "loan_payback",
    amount: 5000.00,
    description: "SBA Loan Payment",
    fromAccount: "Operating",
    toAccount: "Loan Account"
  },
  {
    id: 9,
    date: "2025-04-10",
    type: "transfer",
    amount: 20000.00,
    description: "Transfer to tax reserve account",
    fromAccount: "Operating",
    toAccount: "Tax Reserve"
  },
  {
    id: 10,
    date: "2025-04-15",
    type: "owner_draw",
    amount: 5000.00,
    description: "Owner draw - Eric Black",
    fromAccount: "Operating",
    recipient: "Eric Black"
  }
];

export const accountTypes = [
  "Operating",
  "Payroll",
  "Tax Reserve",
  "Loan Account",
  "Equipment Loan",
  "Savings",
  "Investment"
];

export const transactionTypes = [
  { value: "owner_draw", label: "Owner Draw" },
  { value: "loan_payback", label: "Loan Payback" },
  { value: "transfer", label: "Transfer" },
  { value: "other", label: "Other" }
];

export const ownersList = [
  "Jordan Black",
  "Eric Black",
  "Elliott Black",
  "Emmett Black"
];